import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size", "label"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as React from 'react';
import { FormControl } from '@mui/material';
import { CheckedIcon, Icon, StyledFormControlLabel, StyledRadio } from './radio.styles';
import { jsx as _jsx } from "react/jsx-runtime";
var Radio = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var size = _ref.size,
      label = _ref.label,
      restProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsx(FormControl, {
    component: "fieldset",
    children: /*#__PURE__*/_jsx(StyledFormControlLabel, {
      label: label,
      labelPlacement: "end",
      size: size,
      control: /*#__PURE__*/_jsx(StyledRadio, _objectSpread({
        ref: ref,
        size: size,
        checkedIcon: /*#__PURE__*/_jsx(CheckedIcon, {
          size: size
        }),
        icon: /*#__PURE__*/_jsx(Icon, {
          size: size
        })
      }, restProps))
    })
  });
});
Radio.displayName = 'Radio';
export { Radio };